import React, { Fragment, useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { useHistory } from 'react-router'

import { Image } from '../commonComponents';

import AppContext from '../context';
import VMContext from './context';
import { LOOKS_TAB, MAKEUP_TAB, language, LANG_JP, LANG_KR, LANG_SG, LANG_MY, pageDefaultTitle, LANG_RU, LANG_ARABIA_EN, LANG_ARABIA, LANG_ID } from 'Root/constants';

import { AlertMessage } from '../commonComponents';
import { ConfirmationModal } from '../modal';
import { isIFRAMEUrl, defineFilter } from 'Root/utils';
import Tutorial from './Tutorial';
import ProductsTab from './ProductsTab';
import BuyProductButton from './BuyProductButton';
import Perfectcorp from './Perfectcorp';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import content from 'Content/content.json';
import './VirtualMirror.scss';
import CookiePolicyVM from 'Components/cookiePolicy/cookiePolicyVM';
import { imageSet } from 'Components/helper/Images';
import queryString from 'query-string';
import { vm_left_img } from '../../assets/imgs';

const VirtualMirror = (props) => {
  const lensType = Object.keys(content.data.productInfo[language]);

  const history = useHistory();
  const appContext = useContext(AppContext);
  const vmContext = useContext(VMContext);

  const {
    updateProductData,
    updateClearLooks,
  } = appContext;

  const {
    handleLensChange,
    recommendedLensType,
    VMImageLoaded,
    resetSelectedMakeup,
  } = vmContext;
  const { selectedTab } = vmContext;
  const { close } = props;
  const SHOW_COOKIE_POLICY = process.env.REACT_APP_SHOW_COOKIE_POLICY || 'no';

  useEffect(() => {
    if (language === LANG_JP) {
      document.title = pageDefaultTitle + "|vm";
      return () => {
        document.title = pageDefaultTitle;
      }
    }
  });

  const {
    location,
    match: {
      params: { result: quizMultiResult },
    },
  } = props;

  useEffect(() => {
    const previousPath = location.state && location.state.from;
    if(window.sessionStorage.getItem('productInfo')) {
      const productInfo = JSON.parse(window.sessionStorage.getItem('productInfo'));
      if(productInfo.type == 'freshLens') {
        choosePro(productInfo.data, productInfo.index, productInfo.type === 'freshLens' ? 'define' : 'lens')
      }
      else {
        choosePro(productInfo.data, productInfo.index, productInfo.type === 'freshLens' ? 'define' : 'lens')
      }
    }
    else {
      setProName(lensList[0].name);
      choosePro(lensList[0], 0, 'classicLens');
    }
    if (previousPath !== 'quiz') {
      appContext.updateProduct(0, 1);
      appContext.updateRecommendation(-1, -1);
    }

    if (quizMultiResult) {
      const splitResult = quizMultiResult.split('_');
      if (splitResult[2]) {
        vmContext.setVmState({ selectedTab: lensType[splitResult[2]], selectedLensType: lensType[splitResult[2]], recommendedLensType: lensType[splitResult[2]] });
      }
      appContext.updateRecommendation(
        parseInt(splitResult[0]),
        parseInt(splitResult[1])
      );
    }

    return () => {
      appContext.updateProduct(0, 1);
      appContext.updateClearLens(false);
      appContext.updateMakeupCleared(false);
      appContext.updateForceLookReset(false);
      appContext.updateForceMakeupReset(false);
      !vmContext.setVmState.loader && window.YMK && window.YMK.close();
      language === LANG_JP && appContext.updateRecommendation(-1, -1);
    };
  }, []);
  useEffect(() => {
    if (close) {
      vmContext.resetVM();
    }
  }, [close]);

  const closeRemovalPopUp = () => {
    vmContext.setVmState({ showLookRemovalPopUp: false });
    document.body.classList.remove('open');
  };

  const confirmedRemoval = (type) => {
    //If looks tab is selected then lookRemoval will be true
    const lookRemoval = type === LOOKS_TAB;
    vmContext.setVmState({ selectedTab: lookRemoval ? MAKEUP_TAB : LOOKS_TAB });
    if (lookRemoval) {
      vmContext.removeAppliedLook();
    } else {
      vmContext.removeAppliedMakeup();
    }
    vmContext.setVmState({ showLookRemovalPopUp: false });
    document.body.classList.remove('open');
  };

  const splitResult = quizMultiResult ? quizMultiResult.split('_') : false;
  const defaultLensType = quizMultiResult ? splitResult[2]:0;
  const defaultLensID = quizMultiResult ? splitResult[0]:0;
  const {
    data: {
      productInfo: {
        [language]: { [lensType[0]]: lensList },
        [language]: { [lensType[1]]: defineList }
      },
    },
  } = content;
  const { lensCleared, InstagramBackgroundURL } = appContext;
  const values = queryString.parse(window.location.search);
  const [nextLensID, setNextLensID] = useState(defaultLensID);
  const [nextFilterID, setNextFilterID] = useState(parseInt(values.filter));
  const [proName, setProName] = useState('nopro');
  const [type, setType] = useState('notype');
  const [isClassic, setIsClassic] = useState(true);

  const toogleTab = (isClassicTab) => {
    if (isClassic !== isClassicTab) {
      setIsClassic(isClassicTab);
    }
  };


  const choosePro = (item, index, type) => {
    setProName(item.name);
    setType(type);
    appContext.updateClearLens(false);
    handleLensChange(index, 1, type === 'define' ? 'freshLens' : 'classicLens');
    window.sessionStorage.setItem('productInfo', JSON.stringify({
      'data': item,
      'type': type === 'define' ? 'freshLens' : 'classicLens',
      'index': index
    }))
  };

  const changeUrl = () => {
    if(type === 'define') {
      history.push('/define-fresh');
    }
    else {
      history.push('/define-classic');
    }

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  const switchFilterURL = () => {
    var next_lens_id1 = nextLensID;
    if (quizMultiResult) {
      if (nextLensID == content.data.productInfo[language][lensType[splitResult[2]]].length-1) {
        next_lens_id1 = 0;
        setNextLensID(next_lens_id1);
      } else {
        ++next_lens_id1;
        setNextLensID(next_lens_id1);
      }
      const item = lensList[next_lens_id1];
      appContext.updateLensGuid(item.guid, item.key);
      appContext.updateProduct(next_lens_id1, item.id);
      appContext.updateClearLens(false);
      vmContext.handleLensChange(next_lens_id1, 1, selectedTab);
      appContext.updateInstagramBackgroundURL(isIFRAMEUrl() && defineFilter() ? content.data.productInfo[language][selectedLensType][next_lens_id1]['instagram'][defineFilter()]  : '');
    }
  }

  const scrollShop = () => {
    const targetElement = document.getElementById('shop-now');
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' });
    };
  }

  const switchFilterURL2 = () => {
    var next_filter_id = nextFilterID;
    if (quizMultiResult) {
      if(next_filter_id == Object.keys(content.data.productInfo[language][selectedLensType][nextLensID]['instagram']).length) {
        next_filter_id = 1;
        setNextFilterID(next_filter_id);
      } else {
        next_filter_id = next_filter_id + 1;
        setNextFilterID(next_filter_id);
      }
      appContext.updateInstagramBackgroundURL(isIFRAMEUrl() && defineFilter() ? content.data.productInfo[language][selectedLensType][nextLensID]['instagram']["filter"+next_filter_id] : '');
    }
  }
  
  let { result, recommendation } = props.match.params;
  recommendation = result ? result.split('_')[0] : recommendation;
  recommendation = parseInt(recommendation);

  const { showLookRemovalPopUp, actionWillRemove, selectedLensType, lensIndex } = vmContext;

  const isIframe = isIFRAMEUrl();

  return (
    <Fragment>
      

      <section className='virtual-mirror'>
      <div className={language=="twq" || language =="hk" ? "virtual-mirror-wrapper vertical-wrapper" : "virtual-mirror-wrapper"}>
        <h3><FormattedHTMLMessage id="vm.title.block1" defaultMessage="Virtual" /><FormattedHTMLMessage id="vm.title.block2" defaultMessage="Mirror" /></h3>
        <div className="cam-feed" id="YMK-module">
          <Perfectcorp recommendation={recommendation} />
        </div>
        {/* <ProductsTab recommendation={recommendation} /> */}
        <div className="tab-controls">
          <div data-range="classic" onClick={() => toogleTab(true)} className={isClassic ? "tab active" : "tab"}><FormattedHTMLMessage id="vm.defineClassic" defaultMessage="Define® Classic" /></div>
          <div data-range="fresh" onClick={() => toogleTab(false)} className={isClassic ? "tab" : "tab active"}><FormattedHTMLMessage id="vm.defineFresh" defaultMessage="Define® Fresh" /></div>
          <div className="indicator" style={{ transform: isClassic ? "translate(0)" : "translate(100%)" }}></div>
        </div>
        <div className="lens-tray">
          <p><FormattedHTMLMessage id="vm.defineClassic" defaultMessage="Define® Classic" /></p>
          <div className={`collection classic ${isClassic ? 'translate0' : 'translate100'}`}>
            {lensList.map((item, index) => {
              return(
                <figure className={item.name === proName && !lensCleared ? 'active' : ''} data-range='classic' key={index} data-name={item.name} onClick={() => {
                  choosePro(item, index, 'lens');
                }}>
                {item.is_new === 'yes' && (
                  <div className='newproduct' style={{color: item.colors.border}}>new</div>
                )}
                <div className='selection-ring'></div>
                <Image
                  src={imageSet[item.icon]}
                  alt="Recommendation"
                />
                <figcaption dangerouslySetInnerHTML={{ __html: item.name }}></figcaption>
                </figure>
              )
             
              
              })}
          </div>
          <p><FormattedHTMLMessage id="vm.defineFresh" defaultMessage="Define® Fresh" /></p>
          <div className={`collection fresh ${isClassic ? 'translate0' : 'translate-100'}`}>
          {defineList.map((item, index) => {
              return(
                <figure className={item.name === proName && !lensCleared ? 'active' : ''} data-range='classic' key={index} data-name={item.name} onClick={() => {
                  choosePro(item, index, 'define');
                          }}>
                {item.is_new === 'yes' && (
                  <div className='newproduct' style={{color: item.colors.border}}>new</div>
                )}
                <div className='selection-ring' style={{borderColor: item.colors.border}}>
                </div>
                <Image
                  src={imageSet[item.icon]}
                  alt="Recommendation"
                />
                <figcaption dangerouslySetInnerHTML={{ __html: item.name }}></figcaption>
                </figure>
              )
              
              })}
          </div>
        </div>
        { isIframe ? null :<div className="button-stack">
          <a onClick={changeUrl} className={proName != 'nopro' ? 'btn tertiary': 'btn tertiary disabled'} id="learn-more-btn"><FormattedHTMLMessage id="vm.learnmore" defaultMessage="Learn More" /></a>
          <a onClick={() => { scrollShop() }} className="btn tertiary">
            <FormattedHTMLMessage id="vm.shownow" defaultMessage="Show Now" />
            <div className="shopping-cart">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 18">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M14.2221 8.9775C13.9671 9.4425 13.4721 9.75 12.9096 9.75H7.32207L6.49707 11.25H15.4971V12.75H6.49707C5.35707 12.75 4.63707 11.5275 5.18457 10.5225L6.19707 8.6925L3.49707 3H1.99707V1.5H4.44957L5.15457 3H16.2546C16.8246 3 17.1846 3.615 16.9071 4.11L14.2221 8.9775ZM14.9796 4.5H5.86707L7.64457 8.25H12.9096L14.9796 4.5ZM6.49707 13.5C5.67207 13.5 5.00457 14.175 5.00457 15C5.00457 15.825 5.67207 16.5 6.49707 16.5C7.32207 16.5 7.99707 15.825 7.99707 15C7.99707 14.175 7.32207 13.5 6.49707 13.5ZM12.5046 15C12.5046 14.175 13.1721 13.5 13.9971 13.5C14.8221 13.5 15.4971 14.175 15.4971 15C15.4971 15.825 14.8221 16.5 13.9971 16.5C13.1721 16.5 12.5046 15.825 12.5046 15Z"
                />
              </svg>
            </div>
          </a>
        </div>
        }
        <img src={vm_left_img} className='blob'></img>
      </div>
    </section>

    </Fragment>
  );
};

export default withRouter(VirtualMirror);
